import { Box } from '@mui/material';
import CurrencyField from 'components/currency-field/currency-field.component';
import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Rover, useRoverState } from 'reakit';
import * as S from './tip-selector.styles';

const TipSelector = ({
  name = 'tip-selector',
  isAmountMode,
  percentages = isAmountMode ? [0, 1, 2, 3, 5] : [0, 10, 15, 20, 30],
  onChange,
  calculateAmount,
  value,
  percentageValue = percentages[0],
  labelledBy,
}) => {
  const { t } = useTranslation();
  const [tabValue, setTabValue] = useState(percentageValue?.toString());
  const rover = useRoverState({ currentId: tabValue });
  const inputRef = useRef();

  useEffect(() => {
    if (
      percentageValue > -1 &&
      calculateAmount(percentageValue).toString() !== value.toString()
    ) {
      setTabValue(-1);
    }
  }, [calculateAmount, percentageValue, value]);

  useEffect(() => {
    if (
      !percentages.some(
        percentage => percentage.toString() === percentageValue?.toString(),
      )
    ) {
      setTabValue(-1);
    }
  }, [percentages, percentageValue]);

  const handleOnBlur = e => {
    onChange(parseFloat(e.target.value), -1);
  };

  return (
    <Box data-testid="TipSelector.TipTabList">
      <S.TipGroup aria-labelledby={labelledBy} role="radiogroup" id={name}>
        {percentages
          .map(percentage => (
            <Rover
              {...rover}
              as={S.TipButton}
              key={percentage}
              id={percentage.toString()}
              data-testid="TipSelector.TipTab"
              aria-label={
                isAmountMode
                  ? t('tipSelector.tipValueAriaAmount', {
                      tipValue: calculateAmount(percentage),
                    })
                  : t('tipSelector.tipValueAria', {
                      percentage,
                      tipValue: calculateAmount(percentage),
                    })
              }
              aria-describedby={labelledBy}
              role="radio"
              onClick={() => {
                setTabValue(percentage.toString());
                onChange(calculateAmount(percentage), percentage.toString());
              }}
              selected={tabValue === percentage.toString()}
              aria-checked={tabValue === percentage.toString()}
            >
              <Box
                display="flex"
                flexDirection="column"
                alignItems="center"
                justifyContent="center"
              >
                {!isAmountMode && <Box fontSize="12px">{percentage}%</Box>}
                <Box fontSize="14px">${calculateAmount(percentage)}</Box>
              </Box>
            </Rover>
          ))
          .concat([
            <Rover
              {...rover}
              as={S.TipButton}
              key="other"
              id="-1"
              data-testid="TipSelector.TipTab"
              aria-label={t('tipSelector.customTipAria')}
              aria-describedby={labelledBy}
              role="radio"
              onClick={() => {
                setTabValue(-1);
                setTimeout(() => {
                  inputRef.current?.focus();
                }, 0);
              }}
              selected={tabValue === -1}
              aria-checked={tabValue === -1}
            >
              <Box
                display="flex"
                flexDirection="column"
                alignItems="center"
                justifyContent="center"
              >
                <Box>{t('tipSelector.otherLabel')}</Box>
              </Box>
            </Rover>,
          ])}
      </S.TipGroup>
      {tabValue === -1 && (
        <Box display="flex" justifyContent="flex-end" py={1}>
          <CurrencyField
            name="custom_amount"
            value={value}
            onBlur={handleOnBlur}
            onChange={onChange}
            label={t('tipSelector.customTipLabel')}
            inputRef={inputRef}
          />
        </Box>
      )}
    </Box>
  );
};

export default TipSelector;
